<template>
    <div class="container container-tight">
        <div class="row info-bar-row">
            <div class="col-12">
                <section class="info-bar">
                    <div class="info-bar-header">
                        <i class="ipic_info"></i>
                        <h6>{{ $t('info_message') }}</h6>
                    </div>
                    <div class="info-bar-body">
                        <p>{{ $t('info_message_content') }}</p>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {

        }
    },
}
</script>